<template>
    <div class="viewport overflow-hidden">
        <div class="container">
            <h1 class="viewport-header">
                <div class="flex absolute watermark">ČLÁNKY</div>
                Zaujímavosti
            </h1>

            <div class="articleContainer full-width">
                <div
                    v-if="$e.is.empty(articleList)"
                    class="noDataPanel"
                >
                    Žiadne dáta na zobrazenie
                </div>
                <div
                    v-else
                    class="row justify-center"
                    :class="{
                        'q-col-gutter-sm': $q.screen.lt.md,
                        'q-col-gutter-lg': $q.screen.lt.lg && $q.screen.gt.xs,
                        'q-col-gutter-xl': $q.screen.gt.md,
                    }"
                >
                    <Animation
                        v-for="(article, index) in articleList"
                        :key="index"
                        animationName="animate__fadeInUp"
                        inView
                        :customDelay="{ [`${index * 0.1}s`]: $q.screen.gt.sm }"
                        class="flex justify-center col-12 col-md-4"
                    >
                        <div class="flex column article">
                            <q-img
                                :src="article.imageSrc.linkThumbnail2"
                                :ratio="16 / 9"
                                class="image col-shrink cursor-pointer"
                                @click="$router.push({ name: 'clanok', params: { id: article.articleId } })"
                            />
                            <div class="flex column clanok-content col-grow">
                                <div class="date">{{ article.dateTime.date }}</div>
                                <div class="title q-mb-md">
                                    <router-link
                                        :to="{ name: 'clanok', params: { id: article.articleId } }"
                                        class="ellipsis-2-lines"
                                    >
                                        {{ article.title }}
                                    </router-link>
                                </div>
                                <div class="text ellipsis-3-lines">
                                    {{ article.description }}
                                </div>
                                <q-space />
                                <div class="readmore q-mt-xl">
                                    <router-link
                                        class="flex"
                                        :to="{ name: 'clanok', params: { id: article.articleId } }"
                                        ><svg
                                            viewBox="0 0 877.7142857142857 1024"
                                            class="icon q-mr-sm"
                                        >
                                            <path
                                                d="M734.286 512c0-9.714-3.429-18.857-10.286-25.714l-258.857-258.857c-6.857-6.857-16-10.286-25.714-10.286s-18.857 3.429-25.714 10.286l-52 52c-6.857 6.857-10.286 16-10.286 25.714s3.429 18.857 10.286 25.714l108 108h-286.857c-20 0-36.571 16.571-36.571 36.571v73.143c0 20 16.571 36.571 36.571 36.571h286.857l-108 108c-6.857 6.857-10.857 16-10.857 25.714s4 18.857 10.857 25.714l52 52c6.857 6.857 16 10.286 25.714 10.286s18.857-3.429 25.714-10.286l258.857-258.857c6.857-6.857 10.286-16 10.286-25.714zM877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"
                                            ></path>
                                        </svg>
                                        <span class="text-bold">Čítaj viac</span></router-link
                                    >
                                </div>
                            </div>
                        </div>
                    </Animation>
                </div>
            </div>

            <div
                class="buttonPanel row q-gutter-sm justify-center"
                v-if="!$e.is.empty(articleList)"
            >
                <Animation
                    animationName="animate__fadeInUp"
                    inView
                    delay="0.7s"
                >
                    <CButton
                        to="/clanky"
                        color="primary"
                        label="Zobraziť ďalšie články"
                    />
                </Animation>
            </div>
        </div>
    </div>
</template>

<script>
import Animation from '@/components/animation.vue';
import CButton from '@/components/CButton.vue';

export default {
    name: 'VpClanky',
    props: {
        articleList: null,
    },
    components: {
        Animation,
        CButton,
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.article {
    max-width: $breakpoint-sm-min;
    width: 100%;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    @include border-radius(15px);
    @include box-shadow(0px 10px 70px 0px rgba(0, 0, 0, 0.1));
    .image {
        height: 300px;
        width: 100%;
    }

    .clanok-content {
        padding: 48px 40px;
        width: 100%;
        .date {
            color: #848484;
        }

        .title {
            display: flex;
            font-weight: 600;
            font-size: em(24);
        }

        .readmore {
            display: flex;
            font-size: 18px;
        }
    }
}

@media (max-width: $breakpoint-xs-max) {
    .container {
        padding: 70px 0px;

        .viewport-header {
            padding: 0 15px;
        }

        .article {
            @include border-radius(0);

            .clanok-content {
                padding: 32px 15px;
            }
        }
    }
}
</style>
